/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_SubtitleInputs */

const en_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In accordance with the Accessibility Strengthening Act (BFSG) & EN 301 549`)
};

const de_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemäß Barrierefreiheitsstärkungsgesetz (BFSG) & EN 301 549`)
};

const fr_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformement a la loi sur le renforcement de l'accessibilite (BFSG) et EN 301 549`)
};

const es_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De acuerdo con la Ley de fortalecimiento de la accesibilidad (BFSG) y EN 301 549`)
};

const it_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In conformita con la legge sul rafforzamento dell'accessibilita (BFSG) e EN 301 549`)
};

const nl_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In overeenstemming met de wet op de versterking van de toegankelijkheid (BFSG) en EN 301 549`)
};

const pl_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgodnie z ustawa o wzmocnieniu dostepnosci (BFSG) i EN 301 549`)
};

const fi_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esteettömyyslain (BFSG) ja EN 301 549 mukaisesti`)
};

const da_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I overensstemmelse med loven om staerket tilgaengelighed (BFSG) og EN 301 549`)
};

const sv_a11y_statement_subtitle = /** @type {(inputs: A11y_Statement_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I enlighet med lagen om starkt tillganglighet (BFSG) och EN 301 549`)
};

/**
* | output |
* | --- |
* | "In accordance with the Accessibility Strengthening Act (BFSG) & EN 301 549" |
*
* @param {A11y_Statement_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_subtitle = /** @type {((inputs?: A11y_Statement_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_subtitle(inputs)
	if (locale === "fr") return fr_a11y_statement_subtitle(inputs)
	if (locale === "es") return es_a11y_statement_subtitle(inputs)
	if (locale === "it") return it_a11y_statement_subtitle(inputs)
	if (locale === "nl") return nl_a11y_statement_subtitle(inputs)
	if (locale === "pl") return pl_a11y_statement_subtitle(inputs)
	if (locale === "fi") return fi_a11y_statement_subtitle(inputs)
	if (locale === "da") return da_a11y_statement_subtitle(inputs)
	if (locale === "sv") return sv_a11y_statement_subtitle(inputs)
	return en_a11y_statement_subtitle(inputs)
});